import { Component, OnDestroy, OnInit } from '@angular/core';
import { SignalrService } from '@app/core/signalr.service';
import { TelephonyProvider } from '../../providers/telephony/telephony.provider';
import { FlecxModalService } from '../../services/flecx-modal.service';

@Component({
  selector: 'flecx-modal',
  templateUrl: './flecx-modal-updated.component.html',
  styleUrls: ['./flecx-modal.component.scss'],
})
export class FlecxModalComponent implements OnInit, OnDestroy {
  constructor(public flecxModalService: FlecxModalService) {}

  isOpen = false;
  ngOnInit(): void {}
  ngOnDestroy(): void {}
}
